<script lang="ts">
	//UI
	import RangePresets from "@hitit/hub/src/v7/components/common/RangePresets.svelte";
	import DateRange from "@hitit/hub/src/v7/components/common/DateRange.svelte";
	import ComponentLoading from "../components/common/ComponentLoading.svelte";
	import UseList from "../components/earning/UseList.svelte";
	//Utils
	import { t, api } from "../../stores";
	import { Card, Pagenation } from "@hitit/new_ui/src";
	import { onDestroy } from "svelte";
	import { popup } from "../store";
	import { intervalToUTC } from "@hitit/hub/src/v7/utils";
	//Types
	import type { RewardMinDTO } from "@hitit/api";
	type RangeHandlerEvent = { detail: { start: Date; end: Date } };
	//Props
	export let storeId = "";
	export let range = {
		start: new Date(),
		end: new Date(),
	};
	//Constants
	//Variables
	let loading = false;
	let presentPage = 0;
	let rewardMinDTOs: RewardMinDTO[] = [];
	let totalElements = 0;
	let totalPages = 0;
	$: totalPointPromise = $api.getStoreTotalActiveReward(storeId);
	//Functions
	function rangeHandler(e: RangeHandlerEvent) {
		range = e.detail;
	}
	//Do

	async function getRewardFromStore(
		storeId: string,
		range: Interval,
		page = 0
	) {
		const { startUTC, endUTC } = intervalToUTC(range);
		const response = await $api.getRewardFromStore(
			storeId,
			page,
			startUTC,
			endUTC
		);

		return response.data;
	}
	async function buttonCallback(page: number) {
		try {
			loading = true;
			presentPage = page;
			const data = await getRewardFromStore(storeId, range, presentPage);
			totalPages = data.totalPages;
			totalElements = data.totalElements;
			rewardMinDTOs = data.rewardMinDTOs;
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}

	async function getFirstOrder(qRange: Interval, qStoreId: string) {
		try {
			loading = true;
			presentPage = 0;
			const data = await getRewardFromStore(qStoreId, qRange);
			totalPages = data.totalPages;
			totalElements = data.totalElements;
			rewardMinDTOs = data.rewardMinDTOs;
		} catch (error) {
			console.log(error);
		} finally {
			loading = false;
		}
	}

	$: getFirstOrder(range, storeId);
	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<div class="date-range-container">
		<RangePresets today={new Date()} range={range} on:change={rangeHandler} />
		<DateRange range={range} on:change={rangeHandler} />
	</div>
	<Card noPadding>
		<div class="total-point-container">
			<h3 class="title">{$t('global.point.accumulatedPoints')}</h3>
			<p class="total-amount">
				{#await totalPointPromise}
					<ComponentLoading blockMode />
				{:then response}
					{response.data.totalActiveReward.totalActiveReward || 0}
					P
				{/await}
			</p>
			<p class="description">
				{$t('global.point.accumulated_point_description')}
			</p>
		</div>
	</Card>
	<Card noPadding>
		<div class="list">
			{#if loading}
				<ComponentLoading blockMode />
			{:else}
				<div class="header">
					<h1>{$t('global.point.pointHistory')}</h1>
					<p>{$t('global.total')}{totalElements}{$t('global.count_2')}</p>
				</div>
				<UseList list={rewardMinDTOs} />
				<Pagenation
					buttonCallback={buttonCallback}
					presentPage={presentPage}
					totalPage={totalPages} />
			{/if}
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		gap: 20px;

		.date-range-container {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
		}

		.total-point-container {
			position: relative;
			display: flex;
			width: 100%;
			flex-direction: column;
			padding: 20px 10px;
			border-radius: 5px;
			background-color: #e6e7ed;
			background-image: url("/img/common/pointcoin.png");
			background-repeat: no-repeat;
			background-position: bottom 9.6px right 10px;
			background-size: 110.8px 93.2px;
			.title {
				color: #46474b;
			}
			.total-amount {
				font-size: 1.875rem;
				font-weight: 550;
				margin: 10px 0px 54px 0px;
				color: #46474b;
			}

			.description {
				font-size: 0.875rem;
				color: #6d6f76;
				line-height: 1.25rem;
			}
		}
		.list {
			position: relative;
			display: flex;
			flex-direction: column;
			gap: 20px;
			width: 100%;
			padding: 20px 10px;
			box-sizing: border-box;
			.header {
				display: flex;
				width: 100%;
				align-items: center;
				justify-content: space-between;

				h1 {
					font-weight: 600;
					color: #46474b;
					font-size: 1.25rem;
				}
				p {
					font-weight: 500;
					font-size: 1.25rem;
					color: #46474b;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			.list {
				padding: 30px;
				gap: 30px;

				.header {
					h1 {
						font-size: 2.1875rem;
					}

					p {
						font-size: 1.5rem;
					}
				}
			}

			.total-point-container {
				padding: 30px;
				background-position: bottom 20px right 30px;
				background-size: 162px 136.5px;
				.title {
					font-size: 1.25rem;
				}

				.total-amount {
					margin: 10px 0px 21px 0px;
					font-size: 2.5rem;
				}

				.description {
					font-size: 1rem;
				}
			}
		}
	}

</style>
